<a [routerLink]="['/']" class="app-logo">
  <img src="assets/betbooks_landscape_48px.png" alt="Betbooks Logo" class="app-logo-normal" style="height: 48px; width: auto" />
  <img src="assets/betbooks_landscape_48px.png" alt="Betbooks Logo" class="app-logo-small" style="height: 48px; width: auto" />
</a>
